interface FallingLoadingProps {
  fullScreen?: boolean;
}

const FallingLoading: React.FC<FallingLoadingProps> = ({
  fullScreen = false,
}) => {
  return (
    <div className={fullScreen ? "w-full h-screen" : ""}>
      <div className="snippet" data-title="dot-falling">
        <div className="stage">
          <div className="dot-falling"></div>
        </div>
      </div>
    </div>
  );
};

export default FallingLoading;
